import React, { useRef, useState, useContext } from 'react';

import { ThemeContext } from 'styled-components';
import { InputBox, Label, Input, IconBox } from './InputField.styled';
import { Icon, Name } from '../Icon';

interface IInputField {
  type?: string;
  name?: string;
  children: string;
  placeholder?: string;
  required?: boolean;
  labelToShow?: boolean;
  disabled?: boolean;
  value?: string;
  hidden?: boolean;
}

export const InputField: React.FC<IInputField> = ({
  type = 'text',
  name,
  placeholder,
  required,
  labelToShow,
  disabled,
  value,
  hidden,
  children,
}) => {
  const theme = useContext(ThemeContext);
  const inputRef = useRef(null);

  const [inputType, setInputType] = useState<'text' | 'password'>();

  const onTogglePassword = () => {
    if (inputRef?.current) {
      if (inputRef?.current.type === 'text') {
        inputRef.current.type = 'password';
        if (inputRef.current.value !== '') {
          setInputType('password');
        }
      } else {
        inputRef.current.type = 'text';
        if (inputRef.current.value !== '') {
          setInputType('text');
        }
      }
    }
  };

  return (
    <InputBox $show={labelToShow} hide={hidden}>
      <Label $show={labelToShow} htmlFor={name}>
        {children}
      </Label>
      <Input
        $show={labelToShow}
        type={type}
        maxLength={128}
        name={name}
        id={name}
        placeholder={placeholder || children}
        required={required || children.includes('*')}
        disabled={disabled}
        value={value}
        readOnly={hidden}
        ref={inputRef}
      />

      {type === 'password' && (
        <IconBox
          onClick={onTogglePassword}
          color={inputType === 'text' ? theme.colors.black : '#CBCBD6'}
        >
          <Icon name={Name.GENERAL_HIDE_PASSWORD} />
        </IconBox>
      )}
    </InputBox>
  );
};
